import { Col, Row } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';
import React, { useState } from 'react';

function isEmptyPlaceholder(data) {
  return !!data ? data : 'N.A.';
}

function UnitOfferInfo({ unitOffer }) {
  return (
    <div>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Unit Code:</Col>
        <Col span={16}>
          <Text strong>{unitOffer.code}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Course Offer Code:</Col>
        <Col span={16}>
          <Text strong>
            {unitOffer.courseOffer ? unitOffer.courseOffer.code : ''}
          </Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Unit Offer Id:</Col>
        <Col span={16}>
          <Text strong>{unitOffer.unitOfferId}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Description:</Col>
        <Col span={16}>
          <Text strong>
            {isEmptyPlaceholder(unitOffer.unitDescription)}
          </Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Start Date:</Col>
        <Col span={16}>
          <Text strong>
            {isEmptyPlaceholder(unitOffer.startDateFormatted)}
          </Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>End Date:</Col>
        <Col span={16}>
          <Text strong>
            {isEmptyPlaceholder(unitOffer.endDateFormatted)}
          </Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Max Registrations:</Col>
        <Col span={16}>
          <Text strong>
            {isEmptyPlaceholder(unitOffer.maxRegistrations)}
          </Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Min Registrations:</Col>
        <Col span={16}>
          <Text strong>
            {isEmptyPlaceholder(unitOffer.minRegistrations)}
          </Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Trainer Id:</Col>
        <Col span={16}>
          <Text strong>{isEmptyPlaceholder(unitOffer.trainerId)}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Assessor Id:</Col>
        <Col span={16}>
          <Text strong>{isEmptyPlaceholder(unitOffer.assessorId)}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Notes:</Col>
        <Col span={16}>
          <Text strong>{isEmptyPlaceholder(unitOffer.notes)}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Points:</Col>
        <Col span={16}>
          <Text strong>{isEmptyPlaceholder(unitOffer.points)}</Text>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Feedback Link:</Col>
        <Col span={16}>
          <Paragraph strong copyable>
            {isEmptyPlaceholder(unitOffer.feedbackLink)}
          </Paragraph>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col span={8}>Trainer Feedback Link:</Col>
        <Col span={16}>
          <Paragraph strong copyable>
            {isEmptyPlaceholder(unitOffer.trainerFeedbackLink)}
          </Paragraph>
        </Col>
      </Row>
    </div>
  );
}

export default UnitOfferInfo;
